$(document).ready(function() {
  // Function to Fetch Cart Data and Update Inputs & Cart Count
  function updateCartQuantities() {
    $.getJSON('/cart.js', function(cart) {
      let totalCartCount = 0; // Initialize total cart count

      cart.items.forEach(function(item) {
        let productId = item.id;
        let quantity = item.quantity;
        totalCartCount += quantity; // Add quantity to total count

        // Update the input field for the matching product ID
        $(`.comCount[data-product-id="${productId}"] .num`).val(quantity);
      });

      // Update the cart count in .shopBtn
      $('.shopBtn .num').text(totalCartCount);
    });
  }

  // Call the function on page load
  updateCartQuantities();

  // Increase Quantity (Up Button)
  $(document).on("click", ".up", function() {
    let $button = $(this);
    let cardId = $button.parent().attr("data-section");
    let inputField = $button.siblings(".num");
    let currentQty = parseInt(inputField.val(), 10);
    let productId = $button.closest(".comCount").data("product-id");
    let newQty = currentQty + 1;

    inputField.val(newQty);

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: productId
      },
      dataType: "json",
      success: function() {
        console.log("Added to cart:", productId);  
        $(`#${cardId} .messageAdded`).fadeIn().delay(1000).fadeOut();
        updateCartQuantities(); // Update cart count
      },
      error: function() {
        console.log("Error adding product.");
      }
    });
  });

  // Decrease Quantity (Down Button)
  $(document).on("click", ".down", function() {
    let $button = $(this);
    let inputField = $button.siblings(".num");
    let currentQty = parseInt(inputField.val(), 10);
    let productId = $button.closest(".comCount").data("product-id");
    let cardId = $button.parent().attr("data-section");

    if (currentQty > 0) {
      let newQty = currentQty - 1;
      inputField.val(newQty);

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: {
          quantity: newQty,
          id: productId
        },
        dataType: "json",
        success: function() {
          console.log("Updated cart for product:", productId);  
          $(`#${cardId} .messageRemove`).fadeIn().delay(1000).fadeOut();
          updateCartQuantities(); // Update cart count
        },
        error: function() {
          console.log("Error updating cart.");
        }
      });
    }
  });

});